// extracted by mini-css-extract-plugin
export default {"ac-tooltip":"ac-tooltip_ac-tooltip__55DrN"};